export interface IColors {
    white: string
    black: string
    grey: string

    estadao: string
    estadaoLight: string
    estadaoDark: string

    yellow: string

    red: string

    green: string
}

const colors : IColors =  {
    white: '#fff',
    black: '#000',
    grey: '#2c2c2c',

    estadao: '#2575e8',
    estadaoLight: '#438bf3',
    estadaoDark: '#19519e',

    yellow: '#f0bc00',

    red: '#f02e00',

    green: '#609616',
}

export default colors